module.exports = __webpack_public_path__ + "img/2.286eb75d.jpg";